import $ from 'jquery';
import MQ from './onmediaquery';

var MediaQueryLabel = function() {};

MediaQueryLabel.prototype.init = function(options, elem) {
    this.elem = elem;
    this.$elem = $(elem);

    this.options = options;

    this._bindEvents();

    return this;
};

MediaQueryLabel.prototype.is = function(breakpoint) {
    return this.get() === breakpoint;
};

MediaQueryLabel.prototype.get = function() {
    return $('html').attr('data-media-query-breakpoint');
};

MediaQueryLabel.prototype._bindEvents = function() {
    // Add queryable DOM property
    $(document).on('media-query:match', function(e, data) {
        if ($('html').length) {
            $('html').attr('data-media-query-breakpoint', data);
        }
    });

    $(document).ready(function() {
        MQ.init([
            {
                context: '*',
                match: function(breakpoint) {
                    $(document).trigger('media-query:match', breakpoint);
                },
                unmatch: function(breakpoint) {
                    $(document).trigger('media-query:unmatch', breakpoint);
                },
            },
        ]);
    });
};

export default MediaQueryLabel;



// WEBPACK FOOTER //
// ./~/@99designs/asimov/media-query-label/lib/media-query-label.js